import React from 'react';
import { motion } from 'framer-motion';

const OpenSourceV3 = () => {
  return (
    <section className="w-full rounded-2xl bg-gray-50 border border-gray-200">
      <div className="max-w-6xl mx-auto px-6 py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="rounded-xl bg-white p-8 shadow-md hover:shadow-lg hover:-translate-y-2 transition-all duration-300"
        >
          <h2 className="text-4xl font-bold tracking-tight text-gray-900 mb-4">Open Source</h2>
          <p className="text-lg text-gray-600">
            Actively contributing ideas and reusable patterns for Laravel and backend engineering communities.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default OpenSourceV3;
